import {
    ITopology, TopologyVersion,
    useLazyGetTopologyVersionsQuery
} from '../../../../../app/apiSlice';
import * as React from 'react';
import DeleteVersion from './DeleteVersion';
import { CreateVersion } from './CreateVersion';
import { NodeDefinitions } from '../../../editorSlice';
import './TopologyVersions.scss';
import { useEffect, useState } from 'react';
import RestoreVersion from './RestoreVersion';
import { TabPanel, TabView } from 'primereact/tabview';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../../hooks/hooks';
import moment from "moment";
import 'moment/locale/fr';

interface TabVersions {
    [key: string]: TopologyVersion[];
}

export const TopologyVersions = ({topology, catalog}: { topology: ITopology, catalog: NodeDefinitions }) => {

    const [getVersions, {data, ...status}] = useLazyGetTopologyVersionsQuery();
    const lastVersionName = useAppSelector((state) => state.app.config.lastVersionName);
    const [groupedVersions, setGroupedVersions] = useState<TabVersions>({});
    const {t: translate} = useTranslation();

    useEffect(() => {
        getVersions({id: topology.id});
    }, []);

    useEffect(() => {
        if (data) {
            setGroupedVersions(data.reduce((tabVersions: TabVersions, version) => {
                if (version.version !== lastVersionName) {
                    const category = version.versionNamed ? translate('versions.named') : translate('versions.default');
                    if (!tabVersions[category]) {
                        tabVersions[category] = [];
                    }

                    const versionCopy = { ...version, displayname: version.version };
                    if (category == translate('versions.default')) {
                        const parsed = moment.utc(versionCopy.version);
                        const local = parsed.local();
                        versionCopy.displayname = local.format("DD MMMM YYYY, HH:mm:ss");
                    }
                    tabVersions[category].push(versionCopy);
                }
                return tabVersions;
            }, {}))
        }
    }, [data]);

    return <div className="p-2">
        <div className="flex mb-2 py-3">
            <div className="flex-grow-1 mr-1">
                <h1>{translate('versions.title')}</h1>
            </div>
            <CreateVersion topology={topology} catalog={catalog} onDone={() => getVersions({id: topology.id})}/>
        </div>

        {Object.keys(groupedVersions).length === 0 ? <span>{translate('versions.no_version')}</span> : <TabView>
            {Object.entries(groupedVersions).map(([key, versions]) => (
                <TabPanel header={key}>
                    {versions.map((v) =>
                        <div className="row-version" key={v.version}>
                            <span>{v.displayname}</span>
                                <div>
                                    <RestoreVersion version={v} onDone={() => getVersions({id: topology.id})}/>
                                    <DeleteVersion version={v} onDone={() => getVersions({id: topology.id})}/>
                                </div>
                        </div>)}
                </TabPanel>))}
        </TabView>}
    </div>
}